const init = () => {
  const $app = document.querySelector("#app");
  const $div = document.createElement("div");

  $div.style.cssText += ";font-size: 24px;margin: 1rem;";
  $div.innerText = "该应用已下线，若有疑问可以咨询运维同学";

  $app?.append($div);
};

window.onload = init;
